import { Box, Typography } from '@mui/material'
import { Link as RouterLink } from 'react-router-dom'
import { playSmallIcon } from '../../assets/index'
import { HOME_MOBILE_MQ } from '../home/homeMobileLayout'
import { TABLET_MQ } from '../../theme/mobileLayout'

export default function StoryVideoCard({ title, date, image, to = '/stories' }) {
  return (
    <Box
      component={RouterLink}
      to={to}
      sx={{
        position: 'relative',
        display: 'block',
        width: '100%',
        height: { xs: 347, sm: 460, md: 507 },
        [HOME_MOBILE_MQ]: { height: 347 },
        borderRadius: '20px',
        overflow: 'hidden',
        textDecoration: 'none',
        flexShrink: 0,
      }}
    >
      <Box
        component="img"
        src={image}
        alt={title}
        sx={{
          position: 'absolute',
          inset: 0,
          width: '100%',
          height: '100%',
          objectFit: 'cover',
          display: 'block',
        }}
      />
      <Box
        sx={{
          position: 'absolute',
          inset: 0,
          background: 'linear-gradient(180deg, rgba(0,0,0,0.8) 0%, rgba(0,0,0,0) 47%)',
          pointerEvents: 'none',
        }}
      />
      <Box
        sx={{
          position: 'absolute',
          top: 20,
          left: '50%',
          transform: 'translateX(-50%)',
          width: 'min(340px, calc(100% - 40px))',
          display: 'flex',
          flexDirection: 'column',
          gap: '6px',
          color: '#fffefa',
        }}
      >
        <Typography
          sx={{
            fontSize: { xs: 20, md: 24 },
            lineHeight: 'normal',
            fontWeight: 400,
          }}
        >
          {title}
        </Typography>
        <Typography
          sx={{
            fontSize: 14,
            lineHeight: 'normal',
            fontWeight: 400,
            opacity: 0.8,
          }}
        >
          {date}
        </Typography>
      </Box>
      <Box
        sx={{
          position: 'absolute',
          left: 20,
          bottom: 20,
          width: 46,
          height: 46,
          borderRadius: '50%',
          bgcolor: '#fffefa',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          boxSizing: 'border-box',
          p: '15px',
          flexShrink: 0,
          [TABLET_MQ]: {
            width: 52,
            height: 52,
            p: '16px',
          },
        }}
      >
        <Box
          component="img"
          src={playSmallIcon}
          alt=""
          sx={{
            width: 14,
            height: 14,
            display: 'block',
            flexShrink: 0,
            objectFit: 'contain',
            [TABLET_MQ]: {
              width: 15,
              height: 15,
            },
          }}
        />
      </Box>
    </Box>
  )
}
